import { t } from 'i18next';
import * as yup from 'yup';

// matches the API's maxLength for an email subject
export const EMAIL_SUBJECT_MAX_LENGTH = 255;

export const createEmailSubjectSchema = (label: string) =>
  yup
    .string()
    .trim()
    .defined()
    .matches(
      /^[^\r\n]*$/,
      t('form_validation_errors.must_not_contain_line_breaks', { field: label }),
    )
    .max(
      EMAIL_SUBJECT_MAX_LENGTH,
      t('form_validation_errors.max_length', {
        field: label,
        max: EMAIL_SUBJECT_MAX_LENGTH,
      }),
    );
